var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewFavouriteMatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icViewFavouriteMatch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.3535108,152.955329 C36.2563586,151.985548 37.4434356,151.5 38.6321208,151.5 C39.8208059,151.5 41.0138562,151.98555 41.9167232,152.955329 L42.9996122,154.122048 L44.0825203,152.96147 C45.8882351,151.02187 48.8400183,151.021913 50.6457139,152.96147 C52.4514287,154.901028 52.4514287,158.016083 50.6457139,159.955643 C48.1883742,162.59515 45.7321445,165.237605 43.2748239,167.877053 C43.2024941,167.955535 43.1018799,168 42.9966255,168 C42.8913711,168 42.7907569,167.955535 42.7184271,167.877053 L35.3535108,159.949493 C33.5498637,158.008431 33.547796,154.894856 35.3535108,152.955329 Z M49.1391579,145.661513 C49.5655027,145.220704 50.1260668,145 50.6873904,145 C51.2487139,145 51.8120988,145.220704 52.2384526,145.661513 L52.7498169,146.19184 L53.2611901,145.664304 C54.1138888,144.782668 55.5077864,144.782688 56.360476,145.664304 C57.2131747,146.545922 57.2131747,147.961856 56.360476,148.843474 C55.2000656,150.04325 54.0401794,151.244366 52.879778,152.444115 C52.8456222,152.479789 52.79811,152.5 52.7484065,152.5 C52.698703,152.5 52.6511908,152.479789 52.617035,152.444115 L49.1391579,148.840678 C48.2874356,147.958378 48.2864592,146.543116 49.1391579,145.661513 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Favourite-Swipe-I-have-fav-Copy",
    transform: "translate(-34.000000, -145.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icViewFavouriteMatch",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewFavouriteMatch);
export default __webpack_public_path__ + "static/media/icViewFavouriteMatch.8da10650193c3ca2fa44b28b3b9eba18.svg";
export { ForwardRef as ReactComponent };